import { v4 as uuid } from "uuid";

import { MagicPrefix } from "@considr-it/storied-enums";

export const isAnonymousId = (id: string) => {
  return id.includes(MagicPrefix.Anonymous) && !id.includes("@");
};

export const generateAnonymousId = () => MagicPrefix.Anonymous + "-" + uuid();
